import React, { useEffect, useState, Suspense, lazy } from 'react';
import { APIurls, Axios } from '../../constants';
import toast from 'react-hot-toast';
import Loader from './../../components/Loader';

// Lazy loading the sections
const HeroSection = lazy(() => import('../../sections/HeroSection'));
const HomeTextSection = lazy(() => import('../../sections/HomeTextSection'));
const Gallery = lazy(() => import('../../sections/Gallery'));
const HomeAbout = lazy(() => import('../../sections/HomeAbout'));
const Process = lazy(() => import('../../sections/Process'));
const VideoSection = lazy(() => import('../../sections/VideoSection'));
const Testimonial = lazy(() => import('../../sections/Testimonial'));
const Display = lazy(() => import('../../sections/Display'));

const Home = () => {
    const [home, setHome] = useState([]);
    const [projects, setProject] = useState([]);
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getHomeVideos();
    }, []);

    const getHomeVideos = async () => {
        try {
            setLoading(true);
            const res = await Axios.get(APIurls?.getHomeVideos);
            setLoading(false);
            if (res && res?.data?.code === 200) {
                setHome(res?.data?.home || []);
                setProject(res?.data?.projects);
                setTestimonials(res?.data?.testimonials);
            } else {
                setHome([]);
                setProject([]);
            }
        } catch (error) {
            setLoading(false);
            toast.error('Issue in query');
        }
    };

    useEffect(() => {
        window.scroll(0, 0);
    }, []);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator?.userAgent);

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <Suspense fallback={<Loader />}>
                    <HeroSection data={home} />
                    <HomeTextSection />
                    <Gallery data={projects} />
                    <HomeAbout />
                    <Process />
                    <VideoSection />
                    <Testimonial data={testimonials} />
                    <Display data={home} />

                </Suspense>
            )}
        </>
    );
};

export default Home;
